import {SmartComponent} from "smart-component-js";

class CountdownComponent extends SmartComponent {

    constructor(element, parentComponent, params) {
        params = params || {};

        super(element, parentComponent, params);

        this.element = element;

        this.targetDate = new Date(
            Number(this.element.getAttribute('data-countdown'))
        );

        this.daysBox = this.element.querySelector('.days');
        this.hoursBox = this.element.querySelector('.hours');
        this.minutesBox = this.element.querySelector('.minutes');
        this.secondsBox = this.element.querySelector('.seconds');
        this.pastEventLabel = this.element.getAttribute('data-past');
        this.futureEventLabel = this.element.getAttribute('data-future');

        this.labelBox = this.element.querySelector('.countdown__title');

        this.interval = null;

        this.init();
    }

    updateCounter() {

        let now = new Date();
        let diff = this.targetDate - now;

        if (diff <= 0) {
            this.setFinished();
            return;
        }

        let days = Math.floor(
            diff / (1000 * 60 * 60 * 24)
        );

        let hours = Math.floor(
            (diff / (1000 * 60 * 60)) % 24
        );

        let minutes = Math.floor(
            (diff / (1000 * 60)) % 60
        );

        let seconds = Math.floor(
            (diff / 1000) % 60
        );

        this.daysBox.textContent = days;

        this.hoursBox.textContent =
            String(hours).padStart(2, '0');

        this.minutesBox.textContent =
            String(minutes).padStart(2, '0');

        this.secondsBox.textContent =
            String(seconds).padStart(2, '0');

        this.element.classList.remove('is-past');

        if (this.labelBox) {
            this.labelBox.textContent = this.futureEventLabel;
        }
    }

    setFinished() {
        this.stop();

        this.element.classList.add('is-past');

        if (this.labelBox) {
            this.labelBox.textContent = this.pastEventLabel;
        }
    }

    stop() {
        if (this.interval) {
            clearInterval(this.interval);
            this.interval = null;
        }
    }

    init() {

        this.updateCounter();

        if (this.element.classList.contains('is-past')) {
            return;
        }

        this.interval = setInterval(() => {
            this.updateCounter();
        }, 250);
    }
}

export default CountdownComponent;
